module.exports = require("core-js-pure/features/object/get-own-property-symbols");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs3/core-js/object/get-own-property-symbols.js
// module id = 6441
// module chunks = 25